<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />

    <b-card class="bCardGlobal">
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Solicitudes</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>S-00</div>
        </b-col>
      </b-row>

      <div class="divSubtitulo">
        <p class="textoSubtitulo">Bandeja de solicitudes</p>
      </div>
      <b-row>
        <b-col>
          <Recoleccion
            v-if="banderaFlujo == 1 || banderaFlujo == 7"
            :parametros="parametros"
            :banderaFlujo="banderaFlujo"
            :key="banderaFlujo"
          ></Recoleccion>
          <Preparacion
            v-if="banderaFlujo == 2 || banderaFlujo == 6"
            :parametros="parametros"
            :banderaFlujo="banderaFlujo"
            :key="banderaFlujo"
          ></Preparacion>
          <Arribo
            v-if="banderaFlujo == 3 || banderaFlujo == 8"
            :banderaFlujo="banderaFlujo"
            :parametros="parametros"
            :key="banderaFlujo"
          ></Arribo>
          <IngresoCalidad
            v-if="banderaFlujo == 4"
            :parametros="parametros"
            :key="banderaFlujo"
          ></IngresoCalidad>
          <Produccion
            v-if="banderaFlujo == 5"
            :parametros="parametros"
            :key="banderaFlujo"
          ></Produccion>
          <IngresoClinica
            v-if="banderaFlujo == 9"
            :parametros="parametros"
          ></IngresoClinica>

          <b-row>
            <b-col>
              <div class="barra">
                <b-row>
                  <div class="col-sm-12 col-md-4 d-flex text-left">
                    <font-awesome-icon
                    style="color: #17a3b888"
                        class="m-auto m-1"
                        icon="filter"
                    />
                    <b-form-input
                      v-if="tipoBusqueda == 1"
                        class="ml-3 input-filter"
                        placeholder="Nombre del paciente"
                        v-model="filtro.nombre"
                    ></b-form-input>
                    <b-form-input
                      v-if="tipoBusqueda == 2"
                        class="ml-3 input-filter"
                        placeholder="ID del paciente"
                        v-model="filtro.idPaciente"
                    ></b-form-input>
                  </div>
    
                  <div class="col-sm-10 col-md-7 text-right">
                      <b-dropdown
                          variant="ligth"
                          id="dropdown-fechai"
                          :text="texFechaInicio"
                          class="btn-filter"
                      >
                        <b-calendar
                            class="m-2"
                            v-model="filtro.fechaInicio"
                            :max="new Date()"
                            locale="en-US"
                        ></b-calendar>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item-button
                            class="text-right"
                            @click="limpiar(null, 'fechaInicio', null)"
                        >
                          <em class="fa fa-close"></em> Limpiar
                        </b-dropdown-item-button>
                      </b-dropdown>
                      <b-dropdown
                          variant="ligth"
                          id="dropdown-fechaf"
                          :text="texFechaFin"
                          class="btn-filter"
                      >
                        <b-calendar
                            class="m-2"
                            v-model="filtro.fechaFin"
                            :min="
                            filtro.fechaInicio === null
                              ? new Date()
                              : filtro.fechaInicio
                          "
                            :max="new Date()"
                            locale="en-US"
                        ></b-calendar>
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item-button
                            class="text-right"
                            @click="limpiar(null, 'fechaFin', null)"
                        >
                          <em class="fa fa-close"></em> Limpiar
                        </b-dropdown-item-button>
                      </b-dropdown>
                  </div>
                  <div class="col-md-1  col-sm-12 text-right">
                    <span class="btn-clear" @click="limpiarFiltro()"><em class="fa fa-close"></em></span>
                    <b-button
                        variant="primary"
                        :disabled="loader"
                        @click="obtenerDatos()"
                    >
                      <span v-if="!loader"
                      ><font-awesome-icon icon="search"
                      /></span>
                      <span v-else><b-spinner small></b-spinner></span>
                    </b-button>
                  </div>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-form-group v-slot="{ ariaDescribedbyTipoBusqueda }">
        <b-form-radio-group
          id="btn-tipos_busqueda_paciente"
          v-model="tipoBusqueda"
          :options="[
            { text: 'Busq. por nombre de paciente', value: 1 },
            { text: 'Busq. por ID de paciente', value: 2 },
          ]"
          :aria-describedby="ariaDescribedbyTipoBusqueda"
          button-variant="outline-primary"
          size="sm"
          name="radio-btn-outline"
        ></b-form-radio-group>
      </b-form-group>
      <div class="overflow-auto">
        <b-table
          style="border-radius: 50px; margin-top: 2%"
          id="Pendientes"
          thead-tr-class="columnas"
          :items="registros"
          :fields="columnas"
          :per-page="registrosPorPagina"
          :current-page="paginaActual"
          responsive="true"
          class="parrafos"
        >
          <template v-slot:cell(fechaRecepcion)="row">
            {{ row.item.fechaRecepcion | formatoFechaHora }}
          </template>
          <template v-slot:cell(fechaRecepcionEtapa)="row">
            {{ row.item.fechaRecepcionEtapa | formatoFechaHora }}
          </template>
          <template v-slot:cell(Comentarios)="row">
            <b-button-group>
              <b-button
                title="Historial"
                size="sm"
                @click="siguenteFlujo(row.item.idSolicitudEtapa, row.item)"
                variant="info"
                ><em class="fa fa-eye"></em
              ></b-button>
            </b-button-group>
          </template>
        </b-table>
        <div align="center" v-if="loader">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
        <div v-if="!loader">
          <b-alert v-if="registros.length === 0" variant="warning" show
            >No hay datos</b-alert
          >
        </div>
        <div v-if="!loader">
          <b-pagination
            v-if="registros !== undefined && registros.length > 15"
            align="center"
            v-model="paginaActual"
            :total-rows="registros.length"
            :per-page="registrosPorPagina"
            aria-controls="my-table1"
          ></b-pagination>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import Header from "../../../components/Header";
import { MotorService } from "../../../apiServices/motor/MotorService";
import { CatalogosService } from "../../../apiServices/catalogos/CatalogosService";
import { GarantiaService } from "@/apiServices/garantias/GarantiaService";
import { LaboratorioService } from "../../../apiServices/laboratorio/LaboratorioService";
import Recoleccion from "../../../views/laboratorio/Recoleccion";
import Preparacion from "../../../views/LaboratorioEtapa/Preparacion";
import Arribo from "../../../views/LaboratorioEtapa/Arribo";
import IngresoCalidad from "../../../views/LaboratorioEtapa/IngresoCalidad";
import Produccion from "../../../views/LaboratorioEtapa/Produccion";
import IngresoClinica from "../../../views/laboratorio/IngresoClinica";


/* import activacionTratamientos from "../../Pagos/activacionTratamientos"; */
export default {
  name: "BandejaQuejas",
  components: { Header, Recoleccion, Preparacion,Arribo,IngresoCalidad,Produccion,IngresoClinica },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      update: 0,
      tipoBusqueda: 1,
      laboratorioServicio: new LaboratorioService(),
      columnas: [
        { key: "clasificacion", label: "Tipología", sortable: true },
        { key: "idSolicitud", label: "Ticket", sortable: true },
        {
          key: "fechaRecepcion",
          label: "Fecha Recepción ticket",
          sortable: true,
        },
        { key: "persona", label: "Solicitante", sortable: true },
        { key: "atiende", label: "Atiende", sortable: true },
        { key: "etapa", label: "Etapa", sortable: true },
        { key: "no", label: "N°", sortable: true },
        { key: "estatus", label: "Estatus", sortable: true },
        {
          key: "fechaRecepcionEtapa",
          label: "Fecha Recepción Etapa",
          sortable: true,
        },
        "Comentarios",
      ],
      registros: [],
      registrosPorPagina: 15,
      paginaActual: 0,
      filtro: {
        estatusEtapa: [{ idEstatusEtapa: 1, descripcion: "Pendiente" }],
        estatus: [],
        clinicas: [],
        clasificaciones: null,
        nombre: null,
        fechaInicio: null,
        fechaFin: null,
        idPaciente: null,
      },
      search: {
        clinicaSearch: "",
        etapaSearch: "",
        clasificacionSearch: "",
      },
      loader: false,
      motorServicio: new MotorService(),
      catalogoServicio: new CatalogosService(),
      garantiaServicio: new GarantiaService(),
      clasificaciones: [],
      origenes: [],
      clinicas: [],
      etapas: [],
      urlComponent: "",
      parametros: [],
      banderaFlujo: 0,

      estatus: [
        { idEstatusEtapa: 1, descripcion: "Pendiente" },
        { idEstatusEtapa: 2, descripcion: "En proceso" },
        { idEstatusEtapa: 3, descripcion: "Finalizado" },
      ],
    };
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.obtenerDatos();
    this.obtenerClasificaciones();
    this.obtenerOrigenes();
    this.obtenerEtapas();
    this.obtnerClinicas();
  },
  watch: {},
  methods: {
    obtenerDatos() {
      this.loader = true;
      const idEmpleado = this.$localStorageService.getIdEmpleado();
      this.motorServicio
        .obtenerTickets(idEmpleado, this.datosEnvio())
        .then((respuesta) => {
          this.registros = respuesta.data;
        })
        .finally(() => {
          this.loader = false;
        });
    },

    siguenteFlujo(idSolicitudEtapa, item) {
      if (item.estatus === "Finalizado") {
        this.$swal.fire({
          icon: "info",
          text: "Etapa finalizada",
        });
        return false;
      }
      this.banderaFlujo = 0;
      this.parametros = [];
      const params = {
        idSolicitudEtapa: idSolicitudEtapa,
        objeto: null
      }
      this.motorServicio
        .obtenerSiguenteFlujo(params)
        .then((respuesta) => {
          let url = respuesta.data.urlPantalla;
          this.urlComponent = respuesta.data.nombreFlujo;
          this.parametros.push({ idEtapa: respuesta.data.idEtapa });
          if (respuesta.data.parametros.length > 0) {
            url = url + "/";

            respuesta.data.parametros.forEach((p, i) => {
              url = url + p.valor;
              if (i + 1 < respuesta.data.parametros.length) {
                url = url + "/";
              }

              this.parametros[0][p.llave] = p.valor;
            });
            if (this.update != 0) {
              this.update = 0;
            } else {
              this.update = 1;
            }
            this.nombreFlujo = respuesta.data.nombreFlujo;
            switch (this.nombreFlujo) {
              case "Recoleccion":
                this.banderaFlujo = 1;
                break;
              case "Preparacion":
                this.banderaFlujo = 2;
                break;
                case "Arribo":
                this.banderaFlujo = 3;
                break;
                case "Ingreso":
                this.banderaFlujo = 4;
                break;
                case "En producción":
                this.banderaFlujo = 5;
                break;
                case "Preparacion a clinica":
                this.banderaFlujo = 6;
                break;
                case "Recoleccion a clínica":
                this.banderaFlujo = 7;
                break;
                case "Arribo en clínica":
                this.banderaFlujo = 8;
                break;
                case "Ingreso a Clinica":
                this.banderaFlujo = 9;
                break;

              default:
                url = url + "/" + respuesta.data.idEtapa;
                this.$router.push(url);
                break;
            }
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },

    datosEnvio() {
      const envio = JSON.parse(JSON.stringify(this.filtro));

      if (this.filtro.fechaInicio !== null && this.filtro.fechaInicio != "") {
        let fechaActual = this.$moment(this.filtro.fechaInicio).set({
          hour: 0,
          minute: 0,
          second: 0,
          millisecond: 0,
        });
        envio.fechaInicio = fechaActual
          .utc()
          .format("YYYY-MM-DD[T]HH:mm:ss[Z]");
      } else {
        
        envio.fechaInicio = null;
      }
      if (this.filtro.fechaFin !== null && this.filtro.fechaFin != "") {
        let fechaF = this.$moment(this.filtro.fechaFin).set({
          hour: 23,
          minute: 59,
          second: 59,
          millisecond: 999,
        });
        envio.fechaFin = fechaF.utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");
      } else {
        
        envio.fechaFin = null;
      }
      if (this.filtro.clinicas.length > 0) {
        envio.clinicas = this.filtro.clinicas.map((t) => t.idClinica);
      } else {
        envio.clinicas = null;
      }
      if (this.filtro.estatus.length > 0) {
        envio.estatus = this.filtro.estatus.map((t) => t.id);
      } else {
        envio.estatus = null;
      }
      if (this.filtro.estatusEtapa.length > 0) {
        envio.estatusEtapa = this.filtro.estatusEtapa.map(
          (t) => t.idEstatusEtapa
        );
      } else {
        envio.estatusEtapa = null;
      }
      if (
        this.filtro.clasificaciones != null &&
        this.filtro.clasificaciones != ""
      ) {
        envio.clasificaciones = [this.filtro.clasificaciones.idClasificacion];
      } else {
        envio.clasificaciones = null;
      }
      if (this.tipoBusqueda == 1) {
        envio.idPaciente = null;
        envio.nombre = this.filtro.nombre;
        this.filtro.idPaciente = null;
      } else if (
        this.filtro.idPaciente != null &&
        this.filtro.idPaciente != ""
      ) {
        envio.idPaciente = this.filtro.idPaciente;
        envio.nombre = null;
        this.filtro.nombre = null;
      }
      return envio;
    },
    obtenerClasificaciones() {
      this.catalogoServicio.obtenerClasificacionesUsuario().then((response) => {
        this.clasificaciones = response.data;
      });
    },
    obtenerOrigenes() {
      this.garantiaServicio.obtenerOrigenQuejas().then((response) => {
        this.origenes = response.data;
      });
    },

    obtenerEtapas() {
      this.loader = true;
      const id =
        this.filtro.clasificaciones != null && this.filtro.clasificaciones != ""
          ? this.filtro.clasificaciones.idClasificacion
          : 5;

      const params = {
        idClasificacion: id
      }

      this.motorServicio
        .obtenerEtapasPorClasificacion(params)
        .then((respuesta) => {
          this.etapas = respuesta.data;
        })
        .finally(() => {
          this.loader = false;
        });
    },
    obtnerClinicas() {
      this.catalogoServicio.listaClinicas().then((response) => {
        this.clinicas = response;
      });
    },

    limpiar(search, atriburo, valor) {
      if (search != null) {
        this.search[search] = "";
      }
      this.filtro[atriburo] = valor;
    },
    limpiarFiltro() {
      this.filtro = {
        estatus: [],
        clinicas: [],
        clasificaciones: null,
        nombre: null,
        fechaInicio: null,
        fechaFin: null,
      };
    },
  },

  computed: {
    clinicasFiltro() {
      return this.clinicas.filter((item) => {
        return item.strNombre
          .toLowerCase()
          .includes(this.search.clinicaSearch.toLowerCase());
      });
    },
    etapasFiltro() {
      return this.etapas.filter((item) => {
        return item.descripcion
          .toLowerCase()
          .includes(this.search.etapaSearch.toLowerCase());
      });
    },
    clasificacionFiltro() {
      return this.clasificaciones.filter((item) => {
        return item.description
          .toLowerCase()
          .includes(this.search.clasificacionSearch.toLowerCase());
      });
    },
    texClinica() {
      let text = "Clinicas";

      if (this.filtro.clinicas.length === 1) {
        text = this.filtro.clinicas[0].strNombre;
      }
      if (this.filtro.clinicas.length > 1) {
        text =
          this.filtro.clinicas[0].strNombre +
          " (" +
          (this.filtro.clinicas.length - 1) +
          "+" +
          ")";
      }
      return text;
    },
    texEtapa() {
      let text = "Etapa";
      if (this.filtro.estatus.length === 1) {
        text = this.filtro.estatus[0].descripcion;
      }
      if (this.filtro.estatus.length > 1) {
        text =
          this.filtro.estatus[0].descripcion +
          " (" +
          (this.filtro.estatus.length - 1) +
          "+" +
          ")";
      }
      return text;
    },
    texEstatus() {
      let text = "Estatus";
      if (this.filtro.estatusEtapa.length === 1) {
        text = this.filtro.estatusEtapa[0].descripcion;
      }
      if (this.filtro.estatusEtapa.length > 1) {
        text =
          this.filtro.estatusEtapa[0].descripcion +
          " (" +
          (this.filtro.estatusEtapa.length - 1) +
          "+" +
          ")";
      }
      return text;
    },
    texClasificacion() {
      let text = "Clasificaciones";
      // if (this.filtro.clasificaciones.length === 1) {
      //   text = this.filtro.clasificaciones[0].description
      // }
      // if (this.filtro.estatus.length > 1){
      //   text = this.filtro.clasificaciones[0].description + ' ('+(this.filtro.clasificaciones.length-1)+'+'+ ')'
      // }
      if (
        this.filtro.clasificaciones != null &&
        this.filtro.clasificaciones != ""
      ) {
        text = this.filtro.clasificaciones.description;
      }
      return text;
    },
    texFechaInicio() {
      return this.filtro.fechaInicio === null || this.filtro.fechaInicio === ""
        ? "Fecha Inicio"
        : this.filtro.fechaInicio;
    },
    texFechaFin() {
      return this.filtro.fechaFin === null || this.filtro.fechaFin === ""
        ? "Fecha Fin"
        : this.filtro.fechaFin;
    },
  },
};
</script>

<style scoped>
/*::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::*/
.scroll {
  max-height: 500px;
  overflow-y: auto;
}

.barra {
  border-width: 1px;
  border-style: solid;
  border-color: #c2e7ff;
  background: #ffffff;
  margin: 1rem;
  padding: 5px;
  border-radius: 6px;
  text-align: left;
  align-items: center;
}

.row {
  background: transparent !important;
}

.input-filter,
.input-filter:focus {
  background: transparent;
  border: 0px;
  box-shadow: 0 0 0 0 rgb(0 123 255 / 25%);
}
.contenedor-drop {
  overflow: auto;
  max-height: 15em;
}

label {
  font-weight: 100 !important;
}

.btn-clear {
  color: gray;
  position: relative;
  margin-right: 1em;
}
.btn-clear:hover {
  color: black;
  cursor: pointer;
}
.btn-clear:focus {
  color: black;
  box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%);
}
</style>
